import { createAction, handleActions } from 'redux-actions';
import { takeLatest } from 'redux-saga/effects';
import * as apiSystem from 'apiSaga/apiSystem';
import createRequestSaga from 'apiSaga/createRequestSaga';

/***** 액션 타입 선언 *****/

// 0. Response 초기화
const INIT_USER_LIST_RESP = 'system/INIT_USER_LIST_RESP'; // 사용자 목록 초기화
const INIT_GROUP_CODE_LIST_RESP = 'system/INIT_GROUP_CODE_LIST_RESP'; // 그룹코드 초기화
const INIT_DEPT_NM_LIST_RESP = 'system/INIT_DEPT_NM_LIST_RESP'; // 부서명 초기화
const INIT_UPDATE_USER_APPROVAL_RESP = 'system/INIT_UPDATE_USER_APPROVAL_RESP'; // 사용자 승인
const INIT_UPDATE_USER_CANCEL_RESP = 'system/INIT_UPDATE_USER_CANCEL_RESP'; // 사용자 해지
const INIT_USER_INFO_RESP = 'system/INIT_USER_INFO_RESP'; // 사용자 상세 조회
const INIT_UPDATE_USER_INFO_RESP = 'system/INIT_UPDATE_USER_INFO_RESP'; // 사용자 상세 조회
const INIT_SEND_TEMP_PWD_ADMIN_RESP = 'com/INIT_SEND_TEMP_PWD_ADMIN_RESP'; // 비밀번호 초기화
const INIT_USER_EXCEL_LIST_RESP = 'system/INIT_USER_EXCEL_LIST_RESP'; // 사용자 목록 엑셀 초기화

// 1. 사용자 목록 조회
const GET_USER_LIST = 'system/GET_USER_LIST';
const GET_USER_LIST_SUCCESS = 'system/GET_USER_LIST_SUCCESS';
const GET_USER_LIST_FAILURE = 'system/GET_USER_LIST_FAILURE';

// 1. 사용자 엑셀목록 조회
const GET_USER_EXCEL_LIST = 'system/GET_USER_EXCEL_LIST';
const GET_USER_EXCEL_LIST_SUCCESS = 'system/GET_USER_EXCEL_LIST_SUCCESS';
const GET_USER_EXCEL_LIST_FAILURE = 'system/GET_USER_EXCEL_LIST_FAILURE';

// 2. 그룹 코드 조회
const GET_GROUP_CODE_LIST = 'system/GET_GROUP_CODE_LIST';
const GET_GROUP_CODE_LIST_SUCCESS = 'system/GET_GROUP_CODE_LIST_SUCCESS';
const GET_GROUP_CODE_LIST_FAILURE = 'system/GET_GROUP_CODE_LIST_FAILURE';

// 2.2. 부서명 조회
const GET_DEPT_NM_LIST = 'system/GET_DEPT_NM_LIST';
const GET_DEPT_NM_LIST_SUCCESS = 'system/GET_DEPT_NM_LIST_SUCCESS';
const GET_DEPT_NM_LIST_FAILURE = 'system/GET_DEPT_NM_LIST_FAILURE';

// 3. 사용자 승인
const UPDATE_USER_APPROVAL = 'system/UPDATE_USER_APPROVAL';
const UPDATE_USER_APPROVAL_SUCCESS = 'system/UPDATE_USER_APPROVAL_SUCCESS';
const UPDATE_USER_APPROVAL_FAILURE = 'system/UPDATE_USER_APPROVAL_FAILURE';

// 4. 사용자 해지
const UPDATE_USER_CANCEL = 'system/UPDATE_USER_CANCEL';
const UPDATE_USER_CANCEL_SUCCESS = 'system/UPDATE_USER_CANCEL_SUCCESS';
const UPDATE_USER_CANCEL_FAILURE = 'system/UPDATE_USER_CANCEL_FAILURE';

// 5. 사용자 상세 조회
const GET_USER_INFO = 'system/GET_USER_INFO';
const GET_USER_INFO_SUCCESS = 'system/GET_USER_INFO_SUCCESS';
const GET_USER_INFO_FAILURE = 'system/GET_USER_INFO_FAILURE';

// 6. 사용자 해지
const UPDATE_USER_INFO = 'system/UPDATE_USER_INFO';
const UPDATE_USER_INFO_SUCCESS = 'system/UPDATE_USER_INFO_SUCCESS';
const UPDATE_USER_INFO_FAILURE = 'system/UPDATE_USER_INFO_FAILURE';

// 비밀번호 초기화
const SEND_TEMP_PWD_ADMIN = 'com/SEND_TEMP_PWD_ADMIN';
const SEND_TEMP_PWD_ADMIN_SUCCESS = 'com/SEND_TEMP_PWD_ADMIN_SUCCESS';
const SEND_TEMP_PWD_ADMIN_FAILURE = 'com/SEND_TEMP_PWD_ADMIN_FAILURE';

/*************************************그룹관리************************************** */

// 0. Response 초기화
const INIT_GROUP_MNGT_RESP = 'system/INIT_GROUP_MNGT_RESP';
const INIT_GROUP_MNGT_LIST_RESP = 'system/INIT_GROUP_MNGT_LIST_RESP';
const INIT_GROUP_MNGT_EXCEL_LIST_RESP = 'system/INIT_GROUP_MNGT_EXCEL_LIST_RESP';
const INIT_GROUP_MNGT_DETAIL_RESP = 'system/INIT_GROUP_MNGT_DETAIL_RESP';
const INIT_DELETE_GROUP_MNGT_LIST_RESP = 'system/INIT_DELETE_GROUP_MNGT_LIST_RESP';
const INIT_DELETE_GROUP_MNGT_RESP = 'system/INIT_DELETE_GROUP_MNGT_RESP';
const INIT_INSERT_GROUP_MNGT_RESP = 'system/INIT_INSERT_GROUP_MNGT_RESP';
const INIT_UPDATE_GROUP_MNGT_RESP = 'system/INIT_UPDATE_GROUP_MNGT_RESP';

// 1. 초기 공통데이터 조회
const GET_GROUP_MNGT = 'system/GET_GROUP_MNGT';
const GET_GROUP_MNGT_SUCCESS = 'system/GET_GROUP_MNGT_SUCCESS';
const GET_GROUP_MNGT_FAILURE = 'system/GET_GROUP_MNGT_FAILURE';

// 1. 그룹 코드 조회
const GET_GROUP_MNGT_LIST = 'system/GET_GROUP_MNGT_LIST';
const GET_GROUP_MNGT_LIST_SUCCESS = 'system/GET_GROUP_MNGT_LIST_SUCCESS';
const GET_GROUP_MNGT_LIST_FAILURE = 'system/GET_GROUP_MNGT_LIST_FAILURE';
// 1. 그룹 코드 엑셀 조회
const GET_GROUP_MNGT_EXCEL_LIST = 'system/GET_GROUP_MNGT_EXCEL_LIST';
const GET_GROUP_MNGT_EXCEL_LIST_SUCCESS = 'system/GET_GROUP_MNGT_EXCEL_LIST_SUCCESS';
const GET_GROUP_MNGT_EXCEL_LIST_FAILURE = 'system/GET_GROUP_MNGT_EXCEL_LIST_FAILURE';

// 1. 그룹 코드 삭제(다건)
const DELETE_GROUP_MNGT_LIST = 'system/DELETE_GROUP_MNGT_LIST';
const DELETE_GROUP_MNGT_LIST_SUCCESS = 'system/DELETE_GROUP_MNGT_LIST_SUCCESS';
const DELETE_GROUP_MNGT_LIST_FAILURE = 'system/DELETE_GROUP_MNGT_LIST_FAILURE';

// 1. 그룹 코드 삭제
const DELETE_GROUP_MNGT = 'system/DELETE_GROUP_MNGT';
const DELETE_GROUP_MNGT_SUCCESS = 'system/DELETE_GROUP_MNGT_SUCCESS';
const DELETE_GROUP_MNGT_FAILURE = 'system/DELETE_GROUP_MNGT_FAILURE';

// 1. 그룹 코드 조회(상세)
const GET_GROUP_MNGT_DETAIL = 'system/GET_GROUP_MNGT_DETAIL';
const GET_GROUP_MNGT_DETAIL_SUCCESS = 'system/GET_GROUP_MNGT_DETAIL_SUCCESS';
const GET_GROUP_MNGT_DETAIL_FAILURE = 'system/GET_GROUP_MNGT_DETAIL_FAILURE';

// 1. 그룹 코드 등록
const INSERT_GROUP_MNGT = 'system/INSERT_GROUP_MNGT';
const INSERT_GROUP_MNGT_SUCCESS = 'system/INSERT_GROUP_MNGT_SUCCESS';
const INSERT_GROUP_MNGT_FAILURE = 'system/INSERT_GROUP_MNGT_FAILURE';

// 1. 그룹 코드 수정
const UPDATE_GROUP_MNGT = 'system/UPDATE_GROUP_MNGT';
const UPDATE_GROUP_MNGT_SUCCESS = 'system/UPDATE_GROUP_MNGT_SUCCESS';
const UPDATE_GROUP_MNGT_FAILURE = 'system/UPDATE_GROUP_MNGT_FAILURE';

// 0. Response 초기화
export const initGroupMngtResp = createAction(INIT_GROUP_MNGT_RESP);
export const initGroupMngtListResp = createAction(INIT_GROUP_MNGT_LIST_RESP);
export const initGroupMngtExcelListResp = createAction(INIT_GROUP_MNGT_EXCEL_LIST_RESP);
export const initGroupMngtDetailResp = createAction(INIT_GROUP_MNGT_DETAIL_RESP);
export const initDeleteGroupMngtListResp = createAction(INIT_DELETE_GROUP_MNGT_LIST_RESP);
export const initDeleteGroupMngtResp = createAction(INIT_DELETE_GROUP_MNGT_RESP);
export const initInsertGroupMngtResp = createAction(INIT_INSERT_GROUP_MNGT_RESP);
export const initUpdateGroupMngtResp = createAction(INIT_UPDATE_GROUP_MNGT_RESP);

// 1. 그룹관리 초기데이터 조회
export const getGroupMngt = createAction(GET_GROUP_MNGT, (reqParam) => reqParam);
// 2. 그룹관리 목록 조회
export const getGroupMngtList = createAction(GET_GROUP_MNGT_LIST, (reqParam) => reqParam);
// 2. 그룹관리 목록 EXCEL 조회
export const getGroupMngtExcelList = createAction(GET_GROUP_MNGT_EXCEL_LIST, (reqParam) => reqParam);
// 3. 그룹삭제 (다건)
export const deleteGroupMngtList = createAction(DELETE_GROUP_MNGT_LIST, (reqParam) => reqParam);
// 4. 그룹삭제
export const deleteGroupMngt = createAction(DELETE_GROUP_MNGT, (reqParam) => reqParam);
// 5. 그룹관리 상세조회
export const getGroupMngtDetail = createAction(GET_GROUP_MNGT_DETAIL, (reqParam) => reqParam);
// 6. 그룹 등록
export const insertGroupMngt = createAction(INSERT_GROUP_MNGT, (reqParam) => reqParam);
// 7. 그룹 수정
export const updateGroupMngt = createAction(UPDATE_GROUP_MNGT, (reqParam) => reqParam);

const getGroupMngtSaga = createRequestSaga(GET_GROUP_MNGT, apiSystem.getGroupMngt);
const getGroupMngtListSaga = createRequestSaga(GET_GROUP_MNGT_LIST, apiSystem.getGroupMngtList);
const getGroupMngtExcelListSaga = createRequestSaga(GET_GROUP_MNGT_EXCEL_LIST, apiSystem.getGroupMngtExcelList);
const deleteGroupMngtListSaga = createRequestSaga(DELETE_GROUP_MNGT_LIST, apiSystem.deleteGroupMngtList);
const deleteGroupMngtSaga = createRequestSaga(DELETE_GROUP_MNGT, apiSystem.deleteGroupMngt);
const getGroupMngtDetailSaga = createRequestSaga(GET_GROUP_MNGT_DETAIL, apiSystem.getGroupMngtDetail);
const insertGroupMngtSaga = createRequestSaga(INSERT_GROUP_MNGT, apiSystem.insertGroupMngt);
const updateGroupMngtSaga = createRequestSaga(UPDATE_GROUP_MNGT, apiSystem.updateGroupMngt);

/*********************************************************************************** */

// 0. Response 초기화
export const initUserListResp = createAction(GET_USER_LIST); // 사용자 목록 response 초기화
export const initUserExcelListResp = createAction(GET_USER_EXCEL_LIST); // 사용자 엑셀목록 response 초기화

export const initGroupCodeListResp = createAction(INIT_GROUP_CODE_LIST_RESP); // 그룹코드 response 초기화
export const initDeptNmListResp = createAction(INIT_DEPT_NM_LIST_RESP); // 부서명 response 초기화
export const initUpdateUserApprovalResp = createAction(UPDATE_USER_APPROVAL); // 사용자 승인 response 초기화
export const initUpdateUserCancelResp = createAction(UPDATE_USER_CANCEL); // 사용자 해지 response 초기화
export const initUserInfoResp = createAction(GET_USER_INFO); // 사용자 상세 response 초기화
export const initUpdateUserInfoResp = createAction(UPDATE_USER_INFO); // 사용자 수정 response 초기화
export const initSendTempPwdAdminResp = createAction(INIT_SEND_TEMP_PWD_ADMIN_RESP); // 비밀번호 초기화

// 1. 사용자정보 조회
export const getUserList = createAction(GET_USER_LIST, (userInfo) => userInfo);
// 1. 사용자 정보 EXCEL조회
export const getUserExcelList = createAction(GET_USER_EXCEL_LIST, (userInfo) => userInfo);

// 2. 그룹 코드 조회
export const getGroupCodeList = createAction(GET_GROUP_CODE_LIST);
// 2.2. 부서명 조회
export const getDeptNmList = createAction(GET_DEPT_NM_LIST);
// 3. 사용자 승인
export const updateUserApproval = createAction(UPDATE_USER_APPROVAL, (userInfos) => userInfos);
// 4. 사용자 해지
export const updateUserCancel = createAction(UPDATE_USER_CANCEL, (userInfos) => userInfos);
// 5. 사용자 상세 조회
export const getUserInfo = createAction(GET_USER_INFO, (usId) => usId);
// 6. 사용자 수정
export const updateUserInfo = createAction(UPDATE_USER_INFO, (userInfo) => userInfo);
// 7. 비밀번호 초기화
export const sendTempPwdAdmin = createAction(SEND_TEMP_PWD_ADMIN, (userInfo) => userInfo);

const getUserListSaga = createRequestSaga(GET_USER_LIST, apiSystem.getUserList); // 사용자 목록
const getUserExcelListSaga = createRequestSaga(GET_USER_EXCEL_LIST, apiSystem.getUserExcelList); // 사용자 목록엑셀

const getGroupCodeListSaga = createRequestSaga(GET_GROUP_CODE_LIST, apiSystem.getGroupCodeList); // 그룹코드
const getDeptNmListSaga = createRequestSaga(GET_DEPT_NM_LIST, apiSystem.getDeptNmList); // 부서명
const updateUserApprovalSaga = createRequestSaga(UPDATE_USER_APPROVAL, apiSystem.updateUserApproval); // 사용자 승인
const updateUserCancelSaga = createRequestSaga(UPDATE_USER_CANCEL, apiSystem.updateUserCancel); // 사용자 해지
const getUserInfoSaga = createRequestSaga(GET_USER_INFO, apiSystem.getUserInfo); // 사용자
const updateUserInfoSaga = createRequestSaga(UPDATE_USER_INFO, apiSystem.updateUserInfo); // 사용자 해지

//  비밀번호 초기화
const sendTempPwdAdminSaga = createRequestSaga(SEND_TEMP_PWD_ADMIN, apiSystem.sendTempPwdAdmin);

// apiSystemSaga
export function* apiSystemSaga() {
  yield takeLatest(GET_USER_LIST, getUserListSaga);
  yield takeLatest(GET_USER_EXCEL_LIST, getUserExcelListSaga);
  yield takeLatest(GET_GROUP_CODE_LIST, getGroupCodeListSaga);
  yield takeLatest(GET_DEPT_NM_LIST, getDeptNmListSaga);
  yield takeLatest(UPDATE_USER_APPROVAL, updateUserApprovalSaga);
  yield takeLatest(UPDATE_USER_CANCEL, updateUserCancelSaga);
  yield takeLatest(GET_USER_INFO, getUserInfoSaga);
  yield takeLatest(UPDATE_USER_INFO, updateUserInfoSaga);
  yield takeLatest(SEND_TEMP_PWD_ADMIN, sendTempPwdAdminSaga);

  yield takeLatest(GET_GROUP_MNGT, getGroupMngtSaga);
  yield takeLatest(GET_GROUP_MNGT_LIST, getGroupMngtListSaga);
  yield takeLatest(GET_GROUP_MNGT_EXCEL_LIST, getGroupMngtExcelListSaga);
  yield takeLatest(DELETE_GROUP_MNGT_LIST, deleteGroupMngtListSaga);
  yield takeLatest(DELETE_GROUP_MNGT, deleteGroupMngtSaga);
  yield takeLatest(GET_GROUP_MNGT_DETAIL, getGroupMngtDetailSaga);
  yield takeLatest(INSERT_GROUP_MNGT, insertGroupMngtSaga);
  yield takeLatest(UPDATE_GROUP_MNGT, updateGroupMngtSaga);
}

// 초기 상태를 선언
// 요청의 로딩 중 상태는 loading 객체에서 관리
const initialState = {
  getUserListResp: null,
};

const apiSystemResp = handleActions(
  {
    // 0. Response 초기화

    [INIT_USER_LIST_RESP]: (state, action) => ({
      // 사용자 목록
      ...state,
      getUserListResp: null,
    }),
    // 1. 사용자 목록 조회
    [GET_USER_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getUserListResp: action.payload,
    }),
    [GET_USER_LIST_FAILURE]: (state, action) => ({
      ...state,
      getUserListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    [INIT_USER_EXCEL_LIST_RESP]: (state, action) => ({
      // 사용자 목록 엑셀
      ...state,
      getUserExcelListResp: null,
    }),
    // 1. 사용자 목록 엑셀 조회
    [GET_USER_EXCEL_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getUserExcelListResp: action.payload,
    }),
    [GET_USER_EXCEL_LIST_FAILURE]: (state, action) => ({
      ...state,
      getUserExcelListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    [INIT_GROUP_CODE_LIST_RESP]: (state, action) => ({
      // 그룹 코드
      ...state,
      getGroupCodeListResp: null,
    }),
    // 1. 그룹 코드 조회
    [GET_GROUP_CODE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getGroupCodeListResp: action.payload,
    }),
    [GET_GROUP_CODE_LIST_FAILURE]: (state, action) => ({
      ...state,
      getGroupCodeListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    [INIT_DEPT_NM_LIST_RESP]: (state, action) => ({
      // 부서명
      ...state,
      getDeptNmListResp: null,
    }),
    // 1. 부서명 조회
    [GET_DEPT_NM_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getDeptNmListResp: action.payload,
    }),
    [GET_DEPT_NM_LIST_FAILURE]: (state, action) => ({
      ...state,
      getDeptNmListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    [INIT_UPDATE_USER_APPROVAL_RESP]: (state, action) => ({
      // 사용자 승인
      ...state,
      updateUserApprovalResp: null,
    }),
    // 1. 사용자 승인 완료
    [UPDATE_USER_APPROVAL_SUCCESS]: (state, action) => ({
      ...state,
      updateUserApprovalResp: action.payload,
    }),
    [UPDATE_USER_APPROVAL_FAILURE]: (state, action) => ({
      ...state,
      updateUserApprovalResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    [INIT_UPDATE_USER_CANCEL_RESP]: (state, action) => ({
      // 사용자 해지
      ...state,
      updateUserCancelResp: null,
    }),
    // 1. 사용자 해지 완료
    [UPDATE_USER_CANCEL_SUCCESS]: (state, action) => ({
      ...state,
      updateUserCancelResp: action.payload,
    }),
    [UPDATE_USER_CANCEL_FAILURE]: (state, action) => ({
      ...state,
      updateUserCancelResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    [INIT_USER_INFO_RESP]: (state, action) => ({
      // 사용자 상세
      ...state,
      getUserInfoResp: null,
    }),
    // 1. 사용자 상세 조회
    [GET_USER_INFO_SUCCESS]: (state, action) => ({
      ...state,
      getUserInfoResp: action.payload,
    }),
    [GET_USER_INFO_FAILURE]: (state, action) => ({
      ...state,
      getUserInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    [INIT_UPDATE_USER_INFO_RESP]: (state, action) => ({
      // 사용자 수정
      ...state,
      updateUserInfoResp: null,
    }),
    // 1. 사용자 수정 완료
    [UPDATE_USER_INFO_SUCCESS]: (state, action) => ({
      ...state,
      updateUserInfoResp: action.payload,
    }),
    [UPDATE_USER_INFO_FAILURE]: (state, action) => ({
      ...state,
      updateUserInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    // 임시비밀번호 발송
    [INIT_SEND_TEMP_PWD_ADMIN_RESP]: (state, action) => ({
      ...state,
      sendTempPwdAdminResp: null,
    }),

    // 임시비밀번호 발송
    [SEND_TEMP_PWD_ADMIN_SUCCESS]: (state, action) => ({
      ...state,
      sendTempPwdAdminResp: action.payload,
    }),
    [SEND_TEMP_PWD_ADMIN_FAILURE]: (state, action) => ({
      ...state,
      sendTempPwdAdminResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    /*******************그룹관리***************************** */

    [INIT_GROUP_MNGT_RESP]: (state, action) => ({
      ...state,
      getGroupMngtResp: null,
    }),
    // 1. 그룹 코드 조회
    [GET_GROUP_MNGT_SUCCESS]: (state, action) => ({
      ...state,
      getGroupMngtResp: action.payload,
    }),
    [GET_GROUP_MNGT_FAILURE]: (state, action) => ({
      ...state,
      getGroupMngtResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    [INIT_GROUP_MNGT_LIST_RESP]: (state, action) => ({
      ...state,
      getGroupMngtListResp: null,
    }),

    // 1. 그룹 코드 조회
    [GET_GROUP_MNGT_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getGroupMngtListResp: action.payload,
    }),
    [GET_GROUP_MNGT_LIST_FAILURE]: (state, action) => ({
      ...state,
      getGroupMngtListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    [INIT_GROUP_MNGT_EXCEL_LIST_RESP]: (state, action) => ({
      ...state,
      getGroupMngtExcelListResp: null,
    }),
    // 1. 그룹 코드 조회
    [GET_GROUP_MNGT_EXCEL_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getGroupMngtExcelListResp: {
        data: action.payload,
        headers: action.headers,
      },
    }),
    [GET_GROUP_MNGT_EXCEL_LIST_FAILURE]: (state, action) => ({
      ...state,
      getGroupMngtExcelListResp: {
        result_code: 'E999',
        result_message: action.payload,
      },
    }),

    [INIT_GROUP_MNGT_DETAIL_RESP]: (state, action) => ({
      ...state,
      getGroupMngtDetailResp: null,
    }),
    // 1. 그룹 코드 상세조회
    [GET_GROUP_MNGT_DETAIL_SUCCESS]: (state, action) => ({
      ...state,
      getGroupMngtDetailResp: action.payload,
    }),
    [GET_GROUP_MNGT_DETAIL_FAILURE]: (state, action) => ({
      ...state,
      getGroupMngtDetailResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    [INIT_DELETE_GROUP_MNGT_LIST_RESP]: (state, action) => ({
      ...state,
      deleteGroupMngtListResp: null,
    }),
    // 1. 그룹 코드 삭제(다건)
    [DELETE_GROUP_MNGT_LIST_SUCCESS]: (state, action) => ({
      ...state,
      deleteGroupMngtListResp: action.payload,
    }),
    [DELETE_GROUP_MNGT_LIST_FAILURE]: (state, action) => ({
      ...state,
      deleteGroupMngtListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    [INIT_DELETE_GROUP_MNGT_RESP]: (state, action) => ({
      ...state,
      deleteGroupMngtResp: null,
    }),
    // 1. 그룹 코드 삭제
    [DELETE_GROUP_MNGT_SUCCESS]: (state, action) => ({
      ...state,
      deleteGroupMngtResp: action.payload,
    }),
    [DELETE_GROUP_MNGT_FAILURE]: (state, action) => ({
      ...state,
      deleteGroupMngtResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    [INIT_INSERT_GROUP_MNGT_RESP]: (state, action) => ({
      ...state,
      insertGroupMngtResp: null,
    }),
    // 1. 그룹 코드 등록
    [INSERT_GROUP_MNGT_SUCCESS]: (state, action) => ({
      ...state,
      insertGroupMngtResp: action.payload,
    }),
    [INSERT_GROUP_MNGT_FAILURE]: (state, action) => ({
      ...state,
      insertGroupMngtResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    [INIT_UPDATE_GROUP_MNGT_RESP]: (state, action) => ({
      ...state,
      updateGroupMngtResp: null,
    }),
    // 1. 그룹 코드 수정
    [UPDATE_GROUP_MNGT_SUCCESS]: (state, action) => ({
      ...state,
      updateGroupMngtResp: action.payload,
    }),
    [UPDATE_GROUP_MNGT_FAILURE]: (state, action) => ({
      ...state,
      updateGroupMngtResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
  },
  initialState
);

export default apiSystemResp;
